









































import {Component, Prop, Vue} from "vue-property-decorator";
import IComment from "@/models/IComment";
import AppConfig from "@/config/AppConfig";
import humanDuration from "@/directives/human_duration";

@Component({
  directives: {humanDuration}
})
export default class Comment extends Vue {
  public name: string = "Comment";

  @Prop({required: true})
  public comment!: IComment;

  private appConfig(): any {

    return AppConfig;

  }

  private nl2br(str, is_xhtml = true): string {

    if (typeof str === 'undefined' || str === null) {
      return '';
    }

    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';

    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  }




}
